<div fxLayout="row" fxLayoutAlign="start center">
  @if (heartbeat?.batteryPercentage !== undefined) {
    <span [class.warn]="batteryWarning">{{ heartbeat?.batteryPercentage | number: "1.2-2" }}%
    </span>
  }
  <mat-icon svgIcon="{{ batteryIcon }}" matTooltip="{{ batteryTooltip }}" [class.warn]="batteryWarning"></mat-icon>
</div>
